import React from "react";
import { CURRENCY } from "../../contants";

const IconsGrid = ({ headers, data, headerVariable, isCurrency }) => {
  return (
    <div className="row">
      {data ? (
        <>
          {headerVariable ? (
            headerVariable.map((head, index) => {
              return (
                <div className="col-md-6 col-lg-3">
                  <div className="card shadow-none border report-card">
                    <div className="card-body">
                      <div className="row d-flex justify-content-center">
                        <div className="col-9">
                          <p
                            className=" mb-1 font-weight-semibold font-13 "
                            style={{ color: "#f0583c" }}
                          >
                            {head}
                          </p>
                          <h3 className="my-2 font-22">
                            {isCurrency ? CURRENCY : ""}
                            {head.isCurrency && CURRENCY}
                            {data[head] || 0}
                          </h3>
                        </div>

                        <div className="col-3 align-self-center">
                          <div className=" bg-light-alt">
                            <i
                              className={`${head.icon} `}
                              style={{ color: "#f0583c", fontSize: 30 }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : headers ? (
            headers.map((head, index) => {
              return (
                <div className="col-md-6 col-lg-3">
                  <div className="card shadow-none border report-card">
                    <div className="card-body">
                      <div className="row d-flex justify-content-center">
                        <div className="col-9">
                          <p
                            className=" mb-1 font-weight-semibold font-13 "
                            style={{ color: "#2e3846" }}
                          >
                            {head.title}
                          </p>
                          <h3 className="my-2 font-22">
                            {head.isCurrency && CURRENCY}

                            {head.key === 'totalTax' ? data[head.key]?.toFixed(2) : data[head.key] || 0}
                          </h3>
                          {/* <p className="mb-0 text-truncate">
                        <span className="text-success">
                          <i className="mdi mdi-trending-up"></i>10.5%
                        </span>{" "}
                        Completions Weekly
                      </p> */}
                        </div>
                        <div className="col-3 align-self-center">
                          <div>
                            <i
                              className={`${head.icon} `}
                              style={{ color: "#f0583c", fontSize: 30 }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-lg-12">
              <p className="text-center">No Data available</p>
            </div>
          )}
        </>
      ) : (
        <div className="col-lg-12">
          <p className="text-center">No Data available</p>
        </div>
      )}
    </div>
  );
};

export default IconsGrid;
